<template>
	<div class="d-flex" :class="{ flex: buttonFabTextPrefix }">
		<v-dialog
			v-model="menu"
			:disabled="hasFreeTrialEnded"
			class="action-menu"
			content-class="vue-tel-input-menu new-conversation"
			:close-on-content-click="false"
			:persistent="!closeOnClick"
			:min-width="maxWidth"
			:max-width="maxWidth"
			scrollable
			transition=""
			z-index="3000"
			@input="menuInput">
			<template #activator="{ props }">
				<v-btn
					v-if="buttonFab"
					:id="`${buttonId ? buttonId : 'action-fab'}`"
					:class="`action-fab-${action}`"
					v-bind="props"
					icon
					@click="selectAction">
					<v-icon class="action-button-icon">{{ buttonIcon }}</v-icon>
				</v-btn>
				<div v-else-if="buttonFabTextPrefix" class="d-flex flex align-center justify-start w-100 cursor-pointer" v-bind="props">
					<v-btn
						:id="`${buttonId ? buttonId : 'action-fab'}`"
						:class="`action-fab-${action}`"
						v-bind="props"
						icon
						@click="selectAction">
						<v-icon class="action-button-icon" :style="fontSizeStyle">{{ buttonIcon }}</v-icon>
					</v-btn>
					<span class="fab-action-header flex" :style="fontSizeStyle">{{ buttonText }}</span>
				</div>
				<v-btn
					v-else
					:id="`${buttonId ? buttonId : 'action-button'}`"
					v-bind="props"
					:fab="buttonFab"
					:rounded="buttonRounded"
					:class="['responsive-action-button']"
					v-test="`action-fab-${action}`"
					:height="display.smAndDown.value ? 'auto' : ''"
					v-track="`action-fab-${action}-button`"
					:min-height="44"
					size="large"
					@click="selectAction">
					<v-icon v-if="buttonIcon" class="action-button-icon mr-2">{{ buttonIcon }}</v-icon>
					<span class="action-button-text">{{ buttonText }}</span>
				</v-btn>
			</template>

			<ActionDialog
				v-if="menu"
				ref="actionDialog"
				:project-id="projectId"
				:project="project"
				:project-checklist-item-id="projectChecklistItemId"
				:allow-docs="allowDocs"
				:actioning-text-override="actioningTextOverride"
				:show-header="true"
				:tab-action="action"
				@close-menu="closeMenu"
				@uploadCounts="(counts) => $emit('uploadCounts', counts)" />
		</v-dialog>
	</div>
</template>

<script>
	import ActionDialog from "./ActionDialog.vue";
	import { EventBus } from "../helpers/eventBus";
	import { hasFreeTrialEnded } from "../helpers/hasFreeTrialEnded.js";
	import { getVueTelProps } from "@/helpers/phone";
	import api from "../api";
	import { useDisplay } from "vuetify";

	export default {
		components: {
			ActionDialog
		},
		setup() {
			const display = useDisplay();
			return { display };
		},
		props: {
			buttonId: String,
			buttonType: String,
			buttonIcon: String,
			buttonText: String,
			action: String,
			projectId: String,
			project: {
				type: Object,
				required: false
			},
			projectChecklistItemId: {
				type: String,
				default: ""
			},
			allowDocs: {
				type: Boolean,
				default: true
			}
		},
		emits: ["close-parent-menu", "uploadCounts"],
		data() {
			return {
				buttonRounded: false,
				buttonFab: false,
				buttonFabTextPrefix: false,
				vueTelProps: getVueTelProps(),
				starting: false,
				validPhone: false,
				autoSetName: false,
				autoSetNameValue: "",
				menu: false,
				phone: "",
				name: "",
				meetingUrl: "",
				actioningTextOverride: "",
				closeOnClick: true,
				organization: null,
				hasFreeTrialEnded: false,
				fontSizeStyle: null,
				me: null
			};
		},
		computed: {
			maxWidth() {
				return this.display.xs.value ? "100%" : 425;
			},
			alignLeft() {
				return this.display.xs.value ? true : false;
			}
		},
		beforeUnmount() {
			// LSP-16687: EventBus is a module singleton; without $off these subscriptions (and the
			// component they capture) leak for the whole session. $off requires the SAME function
			// reference, which is why the handlers are named methods rather than inline arrows.
			EventBus.$off("DisableCloseOnClick", this.onDisableCloseOnClick);
			EventBus.$off("EnableCloseOnClick", this.onEnableCloseOnClick);
		},
		async mounted() {
			if (this.buttonType == "rounded") {
				this.buttonRounded = "xl";
			} else if (this.buttonType == "fab") {
				this.buttonFab = true;
			} else if (this.buttonType == "textFab") {
				this.buttonFabTextPrefix = true;
			}

			EventBus.$on("DisableCloseOnClick", this.onDisableCloseOnClick);
			EventBus.$on("EnableCloseOnClick", this.onEnableCloseOnClick);
			this.me = await api.getMe();
			this.organization = this.me.organization;
			this.hasFreeTrialEnded = await hasFreeTrialEnded(this.organization, this.me.organizationSubscription);
			this.fontSizeStyle = { fontSize: this.windowWidth / 900 + "rem" };
		},
		methods: {
			onDisableCloseOnClick() {
				this.closeOnClick = false;
			},
			onEnableCloseOnClick() {
				this.closeOnClick = true;
			},
			selectAction() {
				if (this.hasFreeTrialEnded) {
					this.$root.$freeTrialEndedDialog.open(this.organization);
				} else {
					this.menu = true;
					this.$refs.actionDialog?.reset();
				}
			},
			menuInput(value) {
				if (this.hasFreeTrialEnded) {
					this.menu = false;
				}
			},
			closeMenu(conversationId, isBack = false) {
				this.menu = false;
				console.log("ActionButton close " + conversationId);
				if (!isBack) {
					this.$emit("close-parent-menu", conversationId);
				}
			}
		}
	};
</script>
<style scoped>
	.responsive-action-button {
		width: 100%;
		white-space: normal;
		height: auto !important;
		padding: 8px 16px;
	}
	.responsive-action-button:focus::before {
		opacity: 0 !important;
	}
	.fab-action-header {
		text-align: left;
		font-weight: 700;
		margin-left: 16px;
		flex: 1;
	}
	.action-button-text {
		word-break: break-word;
		font-size: 0.875rem;
	}

	.action-button-icon {
		flex-shrink: 0;
	}

	.action-menu {
		z-index: 101;
	}
</style>
